<div class="flex flex-col items-center justify-center h-screen bg-gray-50 p-4">
  <div class="flex flex-col items-center max-w-2xl w-full">
    <div class="flex flex-col items-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mb-4"></div>
      <p class="text-gray-600 text-lg font-semibold">Setting up your portal access…</p>
    </div>
  </div>
</div>
